export const ProjectDetails = [
    {
        title: "Asli Feedback",
        description: "A fullstack web app that allows users to get feedback anonymously from anyone through their personalized link",
        techUsed: "Nextjs, Typescript, mongodb, shad-cn",
        ownerName: "K. Riyasat Ali",
        deploymentLink: "https://asli-feedback.vercel.app/",
        githubLink: "https://github.com/Riyasatt/WhisperChat",
        projectImage: "none"
    },
    {
        title: "Clinic website",
        description: "This website takes the input of a patient and shows various things like YouTube videos, reviews, gallery, etc.",
        techUsed: "EJS, Nodejs",
        ownerName: "Tanmay",
        deploymentLink: "dpmemorial.com",
        githubLink: "github.com/tanmayGypt",
        projectImage: "none"
    },
    {
        title: "Bubble Game",
        description: "In this bubble game, a target number is displayed in a highlighted block, and below it are several bubbles each containing a number. The objective is to pop bubbles containing the same number as the one displayed in the hit block within a certain time limit. Each successful match increases your score by +10 points.",
        techUsed: "HTML || CSS || JAVASCRIPT",
        ownerName: "Sumit Joshi",
        deploymentLink: "https://josum06.github.io/bubble_game/",
        githubLink: "https://github.com/josum06",
        projectImage: "none"
    },
    {
        title: "NFT LendSwap",
        description: "NFT LendSwap is a decentralized NFT lending and borrowing platform built on Solana blockchain. It allows users to lend and borrow NFT assets securely using smart contracts.",
        techUsed: "Solana, Rust",
        ownerName: "Shivank Kapur",
        deploymentLink: "",
        githubLink: "https://github.com/ShivankK26/NFT-LendSwap",
        projectImage: "none"
    },
    {
        title: "NFTify",
        description: "This project is a wild ride into the realm of non-fungible tokens (NFTs), where you can turn your images into unique digital assets on the Solana blockchain.",
        techUsed: "Solana, Nextjs, Typescript",
        ownerName: "Shivank Kapur",
        deploymentLink: "",
        githubLink: "https://github.com/ShivankK26/NFTify",
        projectImage: "none"
    },
    {
        title: "eVault CLI",
        description: "eVault CLI is a command-line tool built using Rust programming language that enables users to manage their passwords securely. With eVault CLI, users can add, view, edit, and store their passwords conveniently and safely.",
        techUsed: "Rust",
        ownerName: "Shivank Kapur",
        deploymentLink: "",
        githubLink: "https://github.com/ShivankK26/eVault-CLI",
        projectImage: "none"
    },
    {
        title: "Rust Inventory Management System",
        description: "Welcome to Rust Inventory Management System! This project is a small retail inventory management system implemented in Rust. It allows store managers to manage inventory, record sales and purchases, generate reports, and ensure security.",
        techUsed: "Rust",
        ownerName: "Shivank Kapur",
        deploymentLink: "",
        githubLink: "https://github.com/ShivankK26/Rust-Inventory-Management-System",
        projectImage: "none"
    },
    {
        title: "CrossZipWrap",
        description: "This repository provides a solution for creating forwarder addresses, enabling users to efficiently bridge funds between different blockchain networks and currencies.",
        techUsed: "Router protocol",
        ownerName: "Shivank Kapur",
        deploymentLink: "",
        githubLink: "https://github.com/ShivankK26/CrossZipWrap",
        projectImage: "none"
    },
    {
        title: "Crypto Wallet Extension",
        description: "I've built a Chrome Extension of a Crypto Wallet where the user can perform numerous operations similar to any other Crypto Wallet, including storing NFTs, Crypto Tokens, and even transferring & exchanging funds.",
        techUsed: "Moralis, JavaScript, Nodejs, Expressjs, React",
        ownerName: "Shivank Kapur",
        deploymentLink: "",
        githubLink: "https://github.com/ShivankK26/Crypto-Wallet-Extension",
        projectImage: "none"
    },
    {
        title: "AniFind",
        description: "AniFind is a webapp that allows users to identify anime scenes from screenshots.",
        techUsed: "ExpressJS, NodeJS, EJS, Bootstrap, Rest API, GraphQL, Multer, Axios",
        ownerName: "Sahil Tyagi",
        deploymentLink: "https://anifind.onrender.com/",
        githubLink: "https://github.com/SahilTyagii/AniFind",
        projectImage: "https://github.com/SahilTyagii/AniFind/blob/main/public/images/preview.png?raw=true"
    },
    {
        title: "Movie Recommendation",
        description: "Personalized movie recommendations based on your favorite genres like action, romance, sci-fi, or horror.",
        techUsed: "HTML, CSS & JS",
        ownerName: "Yash Singh Kuwarbi",
        deploymentLink: "",
        githubLink: "https://github.com/freakyash11/Movie-Recommendation",
        projectImage: "none"
    }
];
